<style>
#v-search {
  background-color: #f5f5f5;
  min-height: 100%;
  font-size: 13px;
  padding-bottom: 20px;
}
#v-search>#footer {
  margin-top: 20px;
}
@media screen and (max-width : 1024px) {
  #eso-s-container{
    width:70%;
  }
  #eso-s-cart {
    width: 30%;
  }
}
#eso-s-container {
  padding-left: 15px;
  padding-right: 15px;
  min-height: 768px;
}
#eso-s-container>.eso-breadcrumb {
  padding-left: 0;
  margin: 10px 0;
}
.eso-s-action .btn-batch {
  width: 100%;
  font-size: 15px;
  height: 42px;
}
.eso-s-list {
  margin-top: 15px;
}
#eso-s-cart {
  margin-top: 92px;
}
.eso-batch-dialog button {
  margin-top: 0px;
  float: right;
  margin-left: 15px;
}
.eso-batch-dialog .el-dialog__body {
  padding: 15px;
}
.eso-s-list>div.tip{
  padding-top: 0;
  margin-top: 0;
  margin-bottom: 15px;
}
.eso-s-list>div.tip .hight-difficult  i.el-icon-information{
  color: #FF9609;
}
.eso-s-list>.table>tbody>tr>td {
  line-height: 2.428571;
}
.eso-s-list .btn_add_all{
  line-height: 15px;
  float: right;
  padding: 8px 15px;
  padding: 8px 7px\0;
  margin-right: 0\0;
}
.eso-s-list>p.loading-bar{
  height: 63px;
  margin-bottom: 25px;
}
.eso-s-list>.tails-error-tips{
  margin-top: 15px;
}
span.batch-tips{
  font-size: 13px;
  color: #777;
  display: inline-block;
  margin-top: 30px;
}
.eso-batch-dialog{
  width: 500px;
}
.eso-s-list>div.tip .hight-difficult , .eso-s-list>div.tip .more-company{
  float: left;
  color: #A2A2A2;
  font-size: 13px;
}
.eso-s-list>div.tip>.remark{
  float: right;
}
.eso-s-list>div.tip .hight-difficult {
  margin-right: 15px;
}
.eso-s-list>div.tip .hight-difficult>i , .eso-s-list>div.tip .more-company>i{
  display: inline-block;
  font-size: 18px;
  float: left;
}
.eso-s-list>div.tip .more-company>i{
  color: #FF4949;
}
.eso-s-list>div.tip .hight-difficult>span , .eso-s-list>div.tip .more-company>span{
  display: inline-block;
  margin-top: 2px;
  margin-left: 5px;
}
</style>

<template>
<div id="v-search">
  <!--<eso-header></eso-header>-->
  <el-row id="eso-s-main" class="container">
    <el-col id="eso-s-container" :span="18">
      <eso-breadcrumb v-bind:breadcrumbs="breadcrumbs"></eso-breadcrumb>
      <el-row class="eso-s-action clearfix">
        <el-col :span="20" class="no-left-padding">
          <eso-search-input v-model="word" @click="search">
          </eso-search-input>
        </el-col>
        <el-col :span="4" class="no-lr-padding">
          <el-button type="primary" class="btn-batch" @click="batchOpen">批量查询</el-button>
          <el-dialog title="批量查询" v-model="batchOpened" size="tiny" custom-class="eso-batch-dialog clearfix">
            <el-input type="textarea" :rows="6" placeholder='请输入关键词,每行一个' v-model="batchWords">
            </el-input>
            <div class="clearfix">
              <span v-show="batchWords" class="batch-tips">请输入关键词,每行一个</span>
              <el-button type="primary" @click="batchSearch">批量查询</el-button>
              <el-button type="default" @click="batchOpened = false">取消</el-button>
            </div>
          </el-dialog>
        </el-col>
      </el-row>
      <div class="eso-s-list eso-panel clearfix">
        <div class="tip">
          <span>优化指数结果 : </span>
          <div class="remark">
            <div class="hight-difficult">
              <i class="el-icon-information"></i>
              <span>属热门词汇，优化难度极大，建议更换</span>
            </div>
            <div class="more-company">
              <i class="iconfont icon-jiagezoushi"></i>
              <span>已超过3家企业优化中，建议更换</span>
            </div>
          </div>
        </div>
        <eso-seo-infos
          :wordInfos="infos.select"
          @addToCart="addToCart"
          @removeToCart="removeToCart"
          @fetchExtendWords="fetchExtendWords"
          @selectInfo="selectInfo"
          ></eso-seo-infos>
          <el-alert v-show="tailsIsError" class="tails-error-tips"
            title="获取推荐词时发生错误，请重试或关系管理员"
            type="error">
          </el-alert>
          <p v-show="tailsIsloaded && infos.tails.length != 0" class="extend-word-tip"><span style="color:#f33b17;">"{{tailsWord}}"</span> 推荐以下关键词 :</p>
          <p class="loading-bar" v-show="!tailsIsloaded && !tailsIsError" v-loading="tailsLoadingVisible" element-loading-text="拼命加载中"></p>
          <transition enter-active-class="animated fadeIn">
            <eso-seo-infos
            v-show="tailsIsloaded && infos.tails.length != 0"
            type="extend"
            :wordInfos="infos.tails"
            @addToCart="addToCart"
            @removeToCart="removeToCart"
            @fetchExtendWords="fetchExtendWords"
            @selectInfo="selectInfo"
            ></eso-seo-infos>
          </transition>
          <p>
            <el-button v-show="tailsIsloaded && infos.tails.length != 0" type="primary" class="btn_add_all" @click="addAllToCart">全部加入列表</el-button>
          </p>
      </div>
    </el-col>
    <el-col id="eso-s-cart" :span="6" class="eso-panel">
      <eso-search-cart
        :carts="infos.cart"
        @removeToCart="removeToCart"
        @resetCart="resetCart"
        ></eso-search-cart>
    </el-col>
  </el-row>
  <!--<eso-footer></eso-footer>-->
</div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
// import esoHeader from '../components/core/header'
// import esoFooter from '../components/core/footer'
import esoBreadcrumb from '../components/core/breadcrumb'
import esoSearchCart from '../components/search/cart'
import esoSearchInput from '../components/search/input'
import esoSeoInfos from '../components/search/infos'

export default {
  name: 'search',
  computed: mapState({ user: state => {
    return state.user
  }}),
  data () {
    return {
      isSuperAdmin: false,
      breadcrumbs: [{
        text: '优化指数查询'
      }],
      batchOpened: false,
      word: '',
      tailsWord: '',
      batchWords: '',
      tailsIsloaded: false,
      tailsLoadingVisible: false,
      tailsIsError: false,
      infos: {
        select: [],
        tails: [],
        cart: []
      }
    }
  },
  created () {
    if (this.$route.params && this.$route.params.word) {
      this.word = this.$route.params.word
    }
  },
  mounted () {
    this.isSuperAdmin = (this.user && this.user.email === 'ysb-admin@yi-z.cn')
    let str = window.localStorage.getItem('orders')
    try {
      if (str && str !== 'null') {
        this.infos.cart = JSON.parse(str)
      }
    } catch (e) {
      console.log(e)
    }
    if (this.word) {
      this.search()
    }
  },
  components: {
    esoBreadcrumb,
    esoSearchCart,
    esoSearchInput,
    esoSeoInfos
  },
  watch: {
    'infos.cart' (val, oldValue) {
      window.localStorage.setItem('orders', JSON.stringify(val))
    }
  },
  methods: {
    bindInfo (keyword, infos) {
      let item = {
        keyword: keyword,
        sindex: 0,
        state: 0,
        sf: 0,
        bz: 0,
        notTails: false,
        disabled: false
      }
      infos.push(item)
      this.selectInfo(item)
    },
    findWordByKey (w) {
      for (let item of this.infos.select) {
        if (item.keyword === w) {
          return item
        }
      }
    },
    fetchExtendWords (word) {
      this.tailsIsError = false
      this.tailsIsloaded = false
      let tailsLoadingCtrl = setTimeout(() => {
        this.tailsLoadingVisible = true
      }, 1000)
      this.tailsWord = word
      this.infos.tails = []
      this.$http.get(`${process.env.API_URI}api/tails`, {
        params: {
          w: this.tailsWord
        }
      }).then(res => {
        window.clearTimeout(tailsLoadingCtrl)
        this.tailsIsloaded = true
        let data = JSON.parse(res.body)
        // let onlySameWord = false
        // console.log(word)
        // if ( data.hits.hits.length === 1 && data.hits.hits[0]._source.keyword === word)
        // console.log(this.infos.tails.length)
        data.hits.hits.forEach(item => {
          let keyword = item._source.keyword
          let index = _.findIndex(this.infos.select, {keyword: keyword})
          if (index === -1) {
            this.bindInfo(keyword, this.infos.tails)
          }
        })

        if (data.hits.hits.length === 0 || (data.hits.hits.length === 1 && data.hits.hits[0]._source.keyword === this.tailsWord)) {
          let item = this.findWordByKey(this.tailsWord)
          item.notTails = true
        }
      }, e => {
        window.clearTimeout(tailsLoadingCtrl)
        // this.tailsIsloaded = true
        this.tailsIsError = true
        this.failed(word, e)
      })
    },
    failed (item, ctx) {
      item.sindex = 0
      item.state = -1
      console.log(ctx)
    },
    selectInfo (item) {
      item.state = 0
      this.$http.get(`${process.env.API_URI}api/wordindex`, {
        params: {
          w: item.keyword
        }
      }).then(res => {
        if (res.body && res.body.sindex) {
          item.disabled = false
          item.sindex = res.body.sindex
          item.sf = res.body.sf
          item.bz = res.body.bz
          if (!(this.isSuperAdmin)) {
            if (res.body.sf >= 10 || res.body.bz >= 3) {
              item.disabled = true
            }
            if (res.body.sindex >= 300) {
              item.disabled = true
            }
          }
          item.state = 1
          if (_.find(this.infos.cart, {keyword: item.keyword})) {
            item.state = 2
          }
        } else {
          this.failed(item, res)
        }
        /* if (!isNaN(res.body)) {
          item.sindex = res.body
          item.state = 1
          if (_.find(this.infos.cart, {keyword: item.keyword})) {
            item.state = 2
          }
        } else {
          this.failed(item, res)
        } */
      }, e => {
        this.failed(item, e)
      })
    },
    addAllToCart () {
      let all = [this.infos.select, this.infos.tails]
      for (let arr of all) {
        for (let item of arr) {
          if (item.state === 1 && !item.disabled) {
            this.addToCart(item)
          }
          // if (item.state === 1 && item.sf < 10 && item.bz < 3) {
        }
      }
    },
    getItem (keyword) {
      let all = [this.infos.select, this.infos.tails]
      for (let arr of all) {
        for (let item of arr) {
          if (item.keyword === keyword) {
            return item
          }
        }
      }
    },
    removeToCart (item) {
      var w = item.keyword
      item = this.getItem(w)
      if (item) {
        item.state = 1
      }
      let index = _.findIndex(this.infos.cart, {keyword: w})
      this.infos.cart.splice(index, 1)
    },
    addToCart (item) {
      item.state = 2
      this.infos.cart.push(item)
    },
    resetCart () {
      for (let item of this.infos.cart) {
        item = this.getItem(item.keyword)
        if (item) {
          item.state = 1
        }
      }
      this.infos.cart = []
    },
    search () {
      let arrWord = this.formatWords(this.word)
      this.word = arrWord.join('，')
      this.infos.select = []
      for (let keyword of arrWord) {
        this.bindInfo(keyword, this.infos.select)
      }
      this.fetchExtendWords(this.infos.select[0].keyword)
    },
    formatWords (str) {
      let result = []
      let words = ''
      if (str.indexOf('\n') !== -1) {
        words = str.split('\n')
      } else {
        words = str.replace(new RegExp('，', 'gm'), ',')
        words = words.split(',')
      }
      let tempObj = {}
      words.forEach(item => {
        if (item.replace(new RegExp(' ', 'gm'), '')) {
          if (!(tempObj[item.trim()])) {
            result.push(item.trim())
            tempObj[item.trim()] = 1
          }
        }
      })
      // result = result.slice(0, 10)
      return result
    },
    batchSearch () {
      this.word = this.batchWords
      this.batchOpened = false
      this.search()
    },
    batchOpen () {
      this.batchOpened = true
      this.batchWords = this.word.split('，').join('\n')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Search.vue?1abd3dfd